import ModalConfirmarAcao from '@/shared/components/modals/ModalProximaAcao';
import ModalNotificacao from '../../modals/ModalNotificacao';
import ModalResponsavel from '../../modals/ModalResponsavel';
import ModalAssinaturas from '../../modals/ModalAssinaturas';
import { ListAllIntershipsOfTheMonthResponseDto, AttendanceSheetResponseDto } from '@/api.types';

interface Props {
  folhaSelecionada?: ListAllIntershipsOfTheMonthResponseDto;
  selectedItem?: ListAllIntershipsOfTheMonthResponseDto;
  showModalResponsavel: boolean;
  setShowModalResponsavel: (v: boolean) => void;
  showModalNotificacaoIndividual: boolean;
  setShowModalNotificacaoIndividual: (v: boolean) => void;
  showModalCriarFolha: boolean;
  setShowModalCriarFolha: (v: boolean) => void;
  showModalCriarFolhas: boolean;
  setShowModalCriarFolhas: (v: boolean) => void;
  showModalNotificacoes: boolean;
  setShowModalNotificacoes: (v: boolean) => void;
  isExecuting: boolean;
  handleCriarFolha: () => void;
  handleGenerateAttendanceSheetsForMonth: () => Promise<void>;
  registros?: [ListAllIntershipsOfTheMonthResponseDto[], number];
  mesBusca: Date;
  showModalAssinaturas: boolean;
  setShowModalAssinaturas: (v: boolean) => void;
  folhaParaAssinaturas: AttendanceSheetResponseDto | null;
}

export function AttendanceSheetsModals({
  folhaSelecionada, selectedItem,
  showModalResponsavel, setShowModalResponsavel,
  showModalNotificacaoIndividual, setShowModalNotificacaoIndividual,
  showModalCriarFolha, setShowModalCriarFolha,
  showModalCriarFolhas, setShowModalCriarFolhas,
  isExecuting, handleCriarFolha, handleGenerateAttendanceSheetsForMonth,
  mesBusca,
  showModalAssinaturas, setShowModalAssinaturas,
  folhaParaAssinaturas,
}: Props) {
  return (
    <>
      {showModalResponsavel && folhaSelecionada && (
        <ModalResponsavel
          show={showModalResponsavel}
          folha={folhaSelecionada}
          handleHide={() => setShowModalResponsavel(false)}
        />
      )}

      {showModalNotificacaoIndividual && folhaSelecionada?.folha && (
        <ModalNotificacao
          show={showModalNotificacaoIndividual}
          folha_id={folhaSelecionada.folha.id}
          handleHide={() => setShowModalNotificacaoIndividual(false)}
        />
      )}

      {showModalCriarFolha && selectedItem && (
        <ModalConfirmarAcao
          tituloDaCaixaDeTexto="Criar folha de frequência"
          corpoDaCaixaDeTexto={`Criar folha para ${selectedItem.estagiario.nome}?`}
          tituloBotaoPrincipal="Criar Folha"
          handleAcaoPrincipal={handleCriarFolha}
          show={showModalCriarFolha}
          executing={isExecuting}
          handleHide={() => setShowModalCriarFolha(false)}
        />
      )}

      <ModalConfirmarAcao
        show={showModalCriarFolhas}
        executing={isExecuting}
        handleHide={() => setShowModalCriarFolhas(false)}
        tituloBotaoPrincipal="Cadastrar Folhas"
        corpoDaCaixaDeTexto={`Deseja criar as folhas de ${mesBusca.toLocaleString('pt-BR', { month: 'long', year: 'numeric' })}?`}
        tituloDaCaixaDeTexto="Criar Folhas de Frequência"
        handleAcaoPrincipal={async () => await handleGenerateAttendanceSheetsForMonth()}
      />

      <ModalAssinaturas
        show={showModalAssinaturas}
        folha={folhaParaAssinaturas}
        handleHide={() => setShowModalAssinaturas(false)}
      />
    </>
  );
}
